import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { ContractFilters } from '../../types/models/contract/contract'

export const transformContractFiltersToUrl = (filters?: ContractFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.year) searchParams.set('year', filters.year.toString())
  if (filters.position) searchParams.set('position', filters.position)

  return searchParams.toString()
}

export const transformUrlToContractFilters = (searchParams: URLSearchParams): ContractFilters => {
  const filters: ContractFilters = {}

  const year = searchParams.get('year')
  if (year) filters.year = parseInt(year)

  const position = searchParams.get('position')
  if (position) filters.position = position as StaffPositionEnum

  return filters
}
